<template>
  <div class="main">
    <GoBack :name="`全部公告`" :type="2" :path="`/mobile/home`"></GoBack>

    <div class="content-box">
      <div
        class="list-box"
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <div
          class="list-item"
          v-for="(item, index) in tableData2"
          :key="index"
          @click="goToDetail(item)"
        >
          <div class="line-box">
            <div class="title">{{ item.title }}</div>
          </div>
          <div class="line-box">
            <div class="date color1">{{ item.dateline | dateFormat }}</div>
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          触底加载更多
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          已经到底了~
        </div>
        <van-empty v-if="tableData2.length === 0" description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import GoBack from "@/components/goBack.vue";
import { getNews } from "@/api/mobile";

export default {
  filters: {
    dateFormat(data) {
      if (!data) return "-";
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],
    };
  },
  methods: {
    // 跳转到公告详情
    goToDetail(item) {
      this.$router.push({
        path: "/mobile/allNewDetails",
        query: { id: item.id },
      });
    },

    // 获取公告列表数据（滚动加载）
    getNewsList(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }

      getNews({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          const list = res.data.list || [];
          if (list.length > 0) {
            this.tableData2 = this.tableData2.concat(list);
            if (list.length === this.size2) {
              this.page2++;
            } else {
              this.flag = true;
            }
          } else {
            this.flag = true;
          }
        }
      });
    },

    // 处理滚动事件
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，加载更多数据
        this.getNewsList();
      }
    },
  },
  components: {
    GoBack,
  },
  created() {
    this.getNewsList();
  },
};
</script>

<style lang="scss" scoped>
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 15px 0;
}

.main {
  min-height: 100vh;
  background-color: #f8f8fa;
  width: 100%;

  .content-box {
    height: calc(100vh - 80px);
    width: 100%;
    position: relative;

    .list-box {
      padding: 0 15px;
      padding-top: 10px;
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - 80px);

      .list-item {
        width: 100%;
        background: #ffffff;
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 17px 15px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        &:active {
          background: #f5f7fa;
        }

        .line-box {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #232323;
          margin-bottom: 12px;

          &:last-child {
            margin-bottom: 0;
          }

          .title {
            font-size: 15px;
            color: #333;
            font-weight: 500;
            line-height: 1.5;
          }

          .date {
            font-size: 13px;
            color: #999;
          }

          .color1 {
            font-size: 13px;
            color: #999;
          }
        }
      }
    }
  }
}
</style>
